import { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { error, trace, warn } from './log';
import { componentMap } from './components';
import { withTracking } from './marketingBanner';

export const renderCampaign = ({
  target,
  componentName,
  componentProps,
  campaignName,
  doNotTrack
}) => {
  if (!target) {
    return error(`You must provide a container element to render a campaign.`);
  }
  if (!componentMap[componentName]) {
    return error(`could not find component with name: ${componentName}`);
  }
  if (!campaignName && !doNotTrack) {
    warn('No campaignName provided, tracking will not work');
  }
  const reactElement = withTracking(
    componentMap[componentName],
    campaignName,
    doNotTrack
  );
  render(createElement(reactElement, componentProps), target);
  trace(`rendered ${componentName}`);
};

export const unmountCampaign = ({ target }) => {
  const removed = unmountComponentAtNode(target);
  trace(`unmounted campaign: ${removed}`);
};

export const injectTesSass = () => import('./tes-sass.scss');
